<script setup>
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiHomeSearch,
    mdiCradle,
    mdiPuzzleRemove,
    mdiTownHall,
    mdiCross,
    mdiPill,
    mdiMedicalBag,
    mdiGymnastics,
    mdiWater,
    mdiCheckDecagram,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import { Inertia } from '@inertiajs/inertia';
// Breeze
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import BaseIcon from "@/Components/BaseIcon.vue";

import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";
import TableSingle from "@/Components/TableSingle.vue";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    action: {
        type: String,
        default: 'view'
    },
    object: Object,
    typeDocuments: Object,
    distritos: Object,
    afps: Object,
    puestolaborales: Object,
    levels: Object,
    roles: Object,
    user: Object,
    courses: Object,
    isAdmin: Boolean,
    entidades: Array,
    collaboratorturns: Object,
    debugInertia: Boolean,
    token_user_collab: String
});

//console.log(props.object)
/* LRR
{
start: '2018-11-19 12:00', // Required.
end: '2018-11-19 14:00', // Required.
// Instead of formatted dates, you can also provide Javascript Date objects:
// start: new Date(2018, 11 - 1, 19, 12, 0),
// end: new Date(2018, 11 - 1, 19, 14, 0),
title: {String}, // Optional.
content: {String}, // Optional.
class: {String}, // Optional - space-separated css classes.
background: {Boolean} // Optional. (Event type not CSS property)
split: {Number|String} // Optional.
allDay: {Boolean} // Optional.
deletable: false // optional - force undeletable when events are editable.
resizable: false // optional - force unresizable when events are editable.
}
*/
const events = [
    { id: 1, start: '2022-12-05 12:00', end: '2022-12-06 12:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', deletable: 1 },
    { id: 2, start: '2022-12-07 12:00', end: '2022-12-07 13:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', split: 1 },
    { id: 3, start: '2022-12-08 12:00', end: '2022-12-08 13:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', allday: 1 },
    { id: 4, start: '2022-12-08 16:00', end: '2022-12-08 18:00', title: 'Más trabajo, está bien', content: 'es mejor que halla más trabajo', resizable: 1 }
]

const notas = {
    "files": [
        { "id": 1, "course": "Geometría", "maestro": "Lenin Rivas", "progress": 71 },
        { "id": 2, "course": "Lenguaje", "maestro": "Lucy Farroñay", "progress": 68 },
        { "id": 3, "course": "Arte", "maestro": "Jorge el Curioso", "progress": 49 },
        { "id": 3, "course": "Sociedad y Ambiente", "maestro": "Dora la Exploradora", "progress": 36 },

    ]
};

//console.log(props.typeDocuments)
// Carga de objeto
const rutaPrefijo = ref('collaborator')
const modulo = ref('Colaborador')
const modulos = ref('Colaboradores')
//const action = ref('view')

const tab = ref(0)

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Persona
    apellidos: props.object ? props.object.apellidos : '',
    nombres: props.object ? props.object.nombres : '',
    id_type_document: props.object ? props.object.id_type_document : 1,// 1 DNI
    num_doc: props.object ? props.object.num_doc : '',
    domicilio: props.object ? props.object.domicilio : '',
    sexo: props.object ? props.object.sexo : 0,
    id_distrito_domicilio: props.object ? (props.object.id_distrito_domicilio ?? null) : null,// Sedeje documento que es posible hacer esto
    referencia: props.object ? props.object.referencia : '',
    fecha_nacimiento: props.object ? props.object.fecha_nacimiento : '',
    id_distrito_nacimiento: props.object ? props.object.id_distrito_nacimiento : null,// Pero se toma null par ambos casos de crear o editar que sea vacío
    telefono: props.object ? props.object.telefono : '',
    celular: props.object ? props.object.celular : '',
    email: props.object ? props.object.email : '',

    // Colaborador
    vivienda: props.object ? props.object.vivienda : null,
    id_puesto_laboral: props.object ? props.object.id_puesto_laboral : null,
    fecha_inicio_laboral: props.object ? props.object.fecha_inicio_laboral : '',
    id_afp: props.object ? props.object.id_afp : null,
    cuenta_bancaria: props.object ? props.object.cuenta_bancaria : '',
    seguro: props.object ? props.object.seguro : '',
    recurso_prestado: props.object ? props.object.recurso_prestado : '',
    note: props.object ? props.object.note : '',
    status: props.object ? props.object.status : 1,
    entity: props.object ? props.object.entity : 0,

    salario: props.object ? props.object.salario : 0,
    tipo_jornal: props.object ? props.object.tipo_jornal : 1,

    // User
    user_status: props.user ? props.user.status : 0,
    //user_email: props.object ? props.object.user_email : null,
    //password: props.object ? props.object.password : null,
    //password_confirmation: props.object ? props.object.password_confirmation : null,
    id_rol: props.user ? props.user.id_rol : null,
    //rol_type: props.object ? props.object.rol_type : null,
    change_password: 0

});

/**
 * 
 * LRR 
 * Incializar valorres
 */


// Usar objecto de 
/*const json = '{"result":true, "count":42}';
const obj = JSON.parse(json);
Y
console.log(JSON.stringify({ x: 5, y: 6 }));
// expected output: "{"x":5,"y":6}"

console.log(JSON.stringify([new Number(3), new String('false'), new Boolean(false)]));
// expected output: "[3,"false",false]"

console.log(JSON.stringify({ x: [10, undefined, function(){}, Symbol('')] }));
// expected output: "{"x":[10,null,null,null]}"

console.log(JSON.stringify(new Date(2006, 0, 2, 15, 4, 5)));
// expected output: ""2006-01-02T15:04:05.000Z""

//const objVivienda[{"attribute_type_id":"5024","description":"Asientos","value":"20","start_date":null,"end_date":null,"duration":null}]
*/

// LRR un simple array para usar sólo option del componente input

const optionsGenero = [
    { id: 0, label: 'Femenino' },
    { id: 1, label: 'Masculino' },
]

const optionsJornal = [
    { id: 1, label: 'Completo' },
    { id: 2, label: 'Parcial' },
]

/* const optionsTamizaje = [
    {id: 0, label: 'Pendiente con compromiso'},
    {id: 1, label: 'Realizado y entregado'},
] */


// Seguro de salud
const optionsSeguroSalud = [
    'Particular',
    'ESSALUD',
    'SIS',
    'Otro',
    'No tiene',
]
const selectSeguroSalud = ref('')
const textSeguroSalud = ref('')
if (props.object && props.object.seguro) {
    let arraySeguroSalud = props.object.seguro.split(' :')
    selectSeguroSalud.value = arraySeguroSalud[0]
    if (arraySeguroSalud[1]) textSeguroSalud.value = arraySeguroSalud[1]
} else {
    selectSeguroSalud.value = optionsSeguroSalud[3]// <-- Selección por defecto al crear
}

// Situación familiar
/* const optionsSituacionFamiliar = [
    'Sus 2 padres y hermanos',
    'Sólo con su mamá',
    'Sólo con su papá',
    'Con otros familiares',
]
const selectSituacionFamiliar = ref('')
const textSituacionFamiliar = ref('')
if (props.object && props.object.obs_situacion_familiar) {
    let arraySituacionFamiliar = props.object.obs_situacion_familiar.split(' : ')
    selectSituacionFamiliar.value = arraySituacionFamiliar[0]
    if (arraySituacionFamiliar[1]) textSituacionFamiliar.value = arraySituacionFamiliar[1]  
} */

// Vivienda
const optionsVivienda = [
    'Casa propia',
    'Casa alquilada',
    'Casa de otros familiares',
    'Casa alquilada',
    'Otro'
]

const selectVivienda = ref('')
const textVivienda = ref('')
if (props.object && props.object.vivienda) {
    let arrayVivienda = props.object.vivienda.split(' :')// <-- ' : ' No se guarda el espacio despues del punto
    selectVivienda.value = arrayVivienda[0]
    if (arrayVivienda[1]) textVivienda.value = arrayVivienda[1]
    /* if (arrayVivienda.length > 1) {
        selectVivienda.value = arrayVivienda[0]
        textVivienda.value = arrayVivienda[1]
    } else {
        let result = props.object.obs_datos_vivienda.replace(' : ', '')
        optionsVivienda.includes(result) ? selectVivienda.value = result : textVivienda.value = result
    } */
} else {
    selectVivienda.value = optionsVivienda[4]// <-- Selección por defecto al crear
}

// Acesso al sistema? // usar user status
//const accesoLogin = ref(0)

// Crear o actualizar
const submit = () => {
    if (props.action == 'create') {
        form.post(route(rutaPrefijo.value + '-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
        });
    } else {
        form.put(route(rutaPrefijo.value + '-actualizar'), {
            onFinish: () => form.reset('apellidos, nombres, email, telefono, celular, obs_aprendizaje'),
        });
    }

};

const showNotas = ref([])

//const cancel = () => {
//if (rutaPrefijo.value=='student') {
//form.obs_aprendizaje = '';
//}
//}

//console.log(props.object)

/* const refreshList = (action) => {
    if (action == 'object') {
        Inertia.reload({ only: ['object']})
    } else if (action == 'curso') {
        Inertia.reload({ only: ['curso']})
    }
} */
</script>

<template>
    <Head :title="object ? object.apellidos + ' ' + object.nombres : 'Nuevo colaborador'" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <div v-if="action != 'create'" class="flex justify-between tab-m">
                <div>
                    <button @click="(tab = 0), (action = 'edit')" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab == 0 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Colaborador</span>
                    </button>
                    <button v-if="isAdmin" @click="(tab = 3)" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab == 3 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Turnos de asistencia</span>
                    </button>
                    <!-- <button @click="(tab=4)" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==4 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Carpeta de recuperación</span>
                    </button>
                    <button @click="(tab=5)" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==5 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Notas</span>
                    </button> -->

                    <button v-if="$page.props.auth.user.id_rol <= 5" @click="(tab = 10)" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab == 10 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Agenda</span>
                    </button>
                </div>
                <div>
                    <Link :href="route('collaborator-list')">
                    <BaseButton color="info" small label=" Volver al listado" class="ml-8 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right" />
                    </Link>
                </div>

            </div>

            <div v-else>
                <div class="min-h-[73px] flex justify-between">
                    <div class="min-h-[73px] flex items-center">
                        <h2 class="font-semibold text-sm lg:text-base text-gray-800 leading-tight">
                            Nuevo colaborador
                        </h2>
                    </div>
                </div>
            </div>


            <BreezeValidationErrors class="mb-4" />

            <!-- In basebutton: @click="route('dashboard')"-->

            <!--<Link :href="route('student-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>

                <a href="/public/studentcreate" target="_blank">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </a>-->

        </template>

        <div class="py-12">
            <div class="mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <template v-if="(tab == 0)">
                    <!-- Action View-->
                    <template v-if="action == 'view'">
                        <!-- <div class="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-4">
                                    <div class="md:col-span-4 bg-white rounded-lg shadow-lg p-6 h-full my-auto">
                                        <div class="grid grid-1 md:grid-cols-4 gap-4 h-full">
                                            <div class="col-span-1 h-auto my-auto">
                                                <img class="max-w-full h-44 lg:h-full rounded-lg border-2 border-gray-600 shadow-xl"
                                                    :src="object.sexo ? '/img/student/boy.png' : '/img/student/girl.png'">
                                            </div>
                                            <div class="col-span-1 md:col-span-3 h-auto my-auto">
                                                <div class="flex items-center h-full justify-start">
                                                    <div>
                                                        <span class="text-lg font-bold">{{
                                                                object.apellidos + ' ' + object.nombres
                                                        }}</span><br>
                                                        <span class="font-bold mr-2">DNI : </span>{{ object.num_doc }}
                                                        <br>
                                                        <span class="font-bold mr-2">Género : </span>{{ object.sexo ?
                                                                'Masculino' :
                                                                'Femenino'
                                                        }}<br>
                                                        <span class="font-bold mr-2">Teléfono : </span> {{
                                                                object.telefono
                                                        }}, celular : {{ object.celular }}<br>
                                                        <span class="font-bold mr-2">Email : </span> {{ object.email }}<br>
                                                        <span class="font-bold mr-2">Dirección : </span> {{
                                                                object.domicilio
                                                        }}, distrito : {{
                                                            object.id_distrito_domicilio ? distritos.find(item => item.id ===
                                                            object.id_distrito_domicilio).label : ''
                                                        }}
                                                    
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="md:col-span-1 my-auto bg-rose-600 rounded-lg shadow-lg p-6 h-full text-center flex justify-center items-center">
                                        <div>
                                            <span class="text-white font-bold">Clase</span><br>
                                            <span class="text-[30px] lg:text-[60px] text-white font-bold">{{
                                                    object.level ? object.level.label_short : ''
                                            }}</span><br>
                                            <span class="text-white font-bold">{{ object.classroom ? object.classroom.label : '' }}</span><br>
                                        </div>

                                    </div>
                                    <div class="md:col-span-3 h-full">
                                        <div class="grid h-full">
                                            <div class="flex justify-center pb-4">
                                                <div
                                                    class="flex flex-row max-w-xl rounded-lg bg-white shadow-lg relative w-full">
                                                    <img class="md:h-auto object-cover w-24 lg:w-44 rounded-l-lg"
                                                        src="/img/student/tutor.png" alt="" />
                                                    <div class="p-6 flex flex-col">
                                                        <div class="flex items-center h-full justify-start">
                                                            <div>
                                                                <h5 class="text-gray-900 text-xl font-bold mb-2">Tutor</h5>
                                                                <p class="text-gray-700 text-base">
                                                                    -
                                                                </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex justify-center">
                                                <div
                                                    class="flex flex-row max-w-xl rounded-lg shadow-lg relative w-full my-auto h-auto">
                                                    <div
                                                        class="basis-1/2 md:h-auto my-auto object-cover rounded-l-lg bg-white p-6">

                                                        <h5 class="text-gray-900 text-xl font-bold">Fecha de Matricula</h5>
                                                    </div>
                                                    <div class="basis-1/2 p-6 text-center w-full bg-rose-600 rounded-r-lg">
                                                        <div class="flex items-center h-full justify-center">
                                                            <p class="text-white text-md font-bold">
                                                                {{ object.fecha_matricula }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="container my-4">
                                    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-8 gap-4">
                                        <div class="col-span-1 md:col-span-2 lg:col-span-5">
                                            <div class="bg-white rounded-lg shadow-lg p-6 h-full">
                                                <h3 class="md:text-2xl text-xl mt-4 mb-4 font-bold">Detalles Personales</h3>

                                                <div class="grid lg:grid-cols-2 md:grid-cols-2 md:gap-4 gap-2">
                
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-sky-500 rounded-lg focus:shadow-outline hover:bg-sky-700">
                                                            <BaseIcon :path="mdiHomeSearch" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Referencia de domicilio</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>{{ object.referencia }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-lime-500 rounded-lg focus:shadow-outline hover:bg-lime-700">
                                                            <BaseIcon :path="mdiCradle" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Fecha de nacimiento</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div> {{ object.fecha_nacimiento }}, Distrito : {{
                                                                        object.id_distrito_nacimiento ? distritos.find(item =>
                                                                
                                                                            item.id === object.id_distrito_nacimiento).label : ''
                                                                }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-rose-500 rounded-lg focus:shadow-outline hover:bg-rose-700">
                                                            <BaseIcon :path="mdiTownHall" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Colegio de procedencia</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>
                                                                    {{ object.id_colegio_procedencia ? colegios.find(item =>
                                                                            item.id ===
                                                                            object.id_colegio_procedencia).label : ''
                                                                    }}
                                                                    Distrito {{ object.id_distrito_colegio ?
                                                                            distritos.find(item =>
                                                                                item.id === object.id_distrito_colegio).label : ''
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-slate-600 rounded-lg focus:shadow-outline hover:bg-slate-800">
                                                            <BaseIcon :path="mdiCross" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Religión </h3>
                                                            <div>{{ object.id_religion ?
                                                                    religions.find(item => item.id === object.id_religion).label :
                                                                    ''
                                                            }}</div>
                                                            
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div> Exnoerado? {{ object.exonerado_religion ? 'Si' : 'No' }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-yellow-400 rounded-lg focus:shadow-outline hover:bg-yellow-600">
                                                            <BaseIcon :path="mdiPill" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Alergia a algún medicamento?</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div> {{ object.alergia ?? 'No' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-green-500 rounded-lg focus:shadow-outline hover:bg-green-700">
                                                            <BaseIcon :path="mdiMedicalBag" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Alguna enfermedad a considerar
                                                            </h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div> {{ object.enfermedad ?? 'No' }} </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-fuchsia-500 rounded-lg focus:shadow-outline hover:bg-fuchsia-700">
                                                            <BaseIcon :path="mdiGymnastics" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">¿Apto para educación física?</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div> {{ object.apto_edu_fisica ? 'Si' : 'No' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-red-600 rounded-lg focus:shadow-outline hover:bg-red-800">
                                                            <BaseIcon :path="mdiWater" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">¿Tamisaje de hemoglobina? </h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>{{ object.tamisaje_hemoglobina ?
                                                                        'Realizado y entregado' :
                                                                        'Pendiente con compromiso'
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-orange-400 rounded-lg focus:shadow-outline hover:bg-orange-700">
                                                            <BaseIcon :path="mdiPuzzleRemove" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Problemas de aprendizaje</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div> {{ object.obs_aprendizaje ?? 'No' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-amber-400 rounded-lg focus:shadow-outline hover:bg-amber-600">
                                                            <BaseIcon :path="mdiCheckDecagram" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Tipo</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>{{ object.type ? 'Antiguo' : 'Nuevo' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="hover:bg-gray-100 flex items-start px-3 py-2 rounded-lg space-x-3">
                                                        <button
                                                            class="inline-flex items-center justify-center w-11 h-11 mr-2 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-800">
                                                            <BaseIcon :path="mdiCreditCardOutline" :size="28" />
                                                        </button>
                                                        <div>
                                                            <h3 class="font-semibold text-lg">Estado financiero</h3>
                                                            <div class="flex space-x-2 items-center text-sm pt-0.5">
                                                                <div>{{ object.status_financiero ? 'Al día' : 'Pago pendiente'
                                                                }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-span-1 md:col-span-2 lg:col-span-3">
                                            <div class="bg-white rounded-lg shadow-lg p-6 h-full">

                                                <div class="flex flex-col items-center h-full w-full justify-center">
                                                    <div class="w-full text-left">
                                                        <h3 class="md:text-2xl text-xl mt-4 mb-4 font-bold">Gráfica de competencias</h3>
                                                    </div>

                                                    <div class="my-auto w-full">
                                                        <CardBox class="w-full">
                                                            <div v-if="chartCompetencias">
                                                                <radar-chart :data="chartCompetencias"
                                                                    class="min-w-[100%]" />
                                                            </div>
                                                            <div v-else>
                                                                No existen notas ...
                                                            </div>
                                                        </CardBox>
                                                    </div>
                                                    


                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="container my-4">
                                    <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                <div class="col-span-1">
                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                        label=" Modificar" class="w-full" />
                                                </div>
                                                <div class="col-span-1">
                                                    <BaseButton v-if="object.status" color="danger" :icon="mdiCloseCircle"
                                                        @click="initModal('desactivar')" label=" Deshabilitar" class="w-full" />
                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                    </template>
                    <!-- Editar -->
                    <template v-else-if="action == 'edit'">
                        <div class="grid grids-col-1 shadow-lg border rounded-md p-4 bg-white">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Modificar datos</h3>
                            <form @submit.prevent="submit">
                                <FormField label="Apellidos y Nombres" required>
                                    <FormControl v-model="form.apellidos" type="text" required placeholder="Apellidos" :readonly="!isAdmin" />
                                    <FormControl v-model="form.nombres" type="text" required placeholder="Nombres" :readonly="!isAdmin" />
                                    <FormControl v-model="form.sexo" type="select" :options="optionsGenero" placeholder="Género" :class="!isAdmin ? 'pointer-events-none' : ''" />
                                </FormField>
                                <FormField label="Email/ Documento" required>
                                    <FormControl v-model="form.email" type="email" :icon="mdiMail" placeholder="Email" required :readonly="!isAdmin" />
                                    <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" :class="!isAdmin ? 'pointer-events-none' : ''" />
                                    <FormControl v-model="form.num_doc" type="text" required :readonly="!isAdmin" />
                                </FormField>
                                <FormField label="Información de contacto/Nacimiento">
                                    <FormControl v-model="form.telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="form.celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="form.fecha_nacimiento" type="date" />
                                    <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>
                                <FormField label="Domicilio">
                                    <FormControl v-model="form.domicilio" type="text" placeholder="Dirección" />
                                    <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="form.referencia" type="text" placeholder="Referencia de domicilio" />
                                </FormField>

                                <!-- Datos de colaborador -->
                                <template v-if="$page.props.auth.user.id_rol <= 3"><!-- Sólo adminsitradores -->
                                    <FormField label="Datos de la vivienda/Situación educativa" :help="form.vivienda = selectVivienda + ' :' + textVivienda" required>
                                        <FormControl v-model="selectVivienda" type="select" :options="optionsVivienda" placeholder="Tipo de vivienda" />
                                        <FormControl v-model="textVivienda" type="text" placeholder="Información adicional" />
                                    </FormField>
                                    <FormField label="Recurso prestado">
                                        <FormControl v-model="form.recurso_prestado" type="text" labelinput="Algún recurso prestado por la institución" tooltipcontent="ejem. laptop, impresora, etc." />
                                    </FormField>

                                    <FormField label="Fecha inicio de labores/Puesto laboral/Afp">
                                        <FormControl v-model="form.fecha_inicio_laboral" type="date" />
                                        <FormControl v-model="form.id_puesto_laboral" type="select" :options="puestolaborales" placeholder="Puesto laboral" />
                                        <FormControl v-model="form.id_afp" type="select" :options="afps" placeholder="AFP" />

                                    </FormField>

                                    <FormField label="Seguro de salud/Cuenta Bancaria" :help="form.seguro = selectSeguroSalud + ' :' + textSeguroSalud">
                                        <FormControl v-model="selectSeguroSalud" type="select" :options="optionsSeguroSalud" />
                                        <FormControl v-model="textSeguroSalud" type="text" :placeholder="selectSeguroSalud == optionsSeguroSalud[0] ? 'Dónde?' : 'Información opcional del seguro'" />
                                        <FormControl v-model="form.cuenta_bancaria" type="text" placeholder="Cuenta bancaria" />
                                    </FormField>
                                    <FormField label="Nota">
                                        <FormControl v-model="form.note" type="textarea" />
                                    </FormField>
                                </template>
                                <FormField label="Datos de Login">
                                    <FormControl v-model="form.user_status" type="yesno" labelinput="Acceso al sistema?" placeholder="tiene acceso" tooltipcontent="Por defecto el usuario es el correo y el password es el documento" />
                                    <FormControl v-if="form.user_status == 1" v-model="form.id_rol" type="select" :options="roles" labelinput="Rol de usuario" tooltipcontenthtml="
                                            <p>
                                                <strong>Gerencial TI</strong> : Para los gerentes, promotores con acceso a todo<br>
                                                <strong>Administrador</strong> : Para los adminsitradores de sistemas y finanzas con acceso a todo, ver, modificar y crear<br>
                                                <strong>Supervisor</strong> : Asistente administrativo o coordinadores con privilegios elevados, puede crear y modificar datos<br>
                                                <strong>Asistente</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas<br>
                                            </p>
                                            " />
                                    <!--  -->
                                    <FormControl v-model="form.change_password" type="yesno" labelinput="Cambiar email y password por defecto?" tooltipcontent="Por defecto el usuario es el correo y el password es el documento, esto para restablecer los valores de acceso iniciales" />
                                    {{ token_user_collab ? 'Último Token: ' + token_user_collab : '' }}
                                </FormField>
                                <template v-if="$page.props.auth.user.id_rol <= 4"><!-- Admin y AdminCoord -->
                                    <FormField label="Estado Empleado">
                                        <FormControl v-model="form.status" type="yesno" labelinput="Empleado activo" placeholder="" tooltipcontent="Si el colaborador está trabjando actualmente" />
                                        <FormControl v-if="entidades.length > 1" v-model="form.entity" type="select" :options="entidades" labelinput="Entidad" placeholder="" tooltipcontent="Empresa a la que tiene contrato" />
                                    </FormField>
                                </template>

                                <template v-if="$page.props.auth.user.id_rol <= 3"><!-- Admins -->
                                    <FormField label="Financiero">
                                        <FormControl v-model="form.salario" type="text" labelinput="Salario" tooltipcontent="Salario mensual" />
                                        <FormControl v-model="form.tipo_jornal" type="select" :options="optionsJornal" labelinput="Tipo Turno" placeholder="" tooltipcontent="Para el cálculo de descuento. Tipo completo días por 30, tipo parcial días laborables" />
                                    </FormField>
                                </template>

                                <div class="flex items-center justify-end mt-4">
                                    <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                    <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                    <Link :href="route('collaborator-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>

                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Actualizar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>
                    <!-- Crear -->
                    <template v-else>
                        <div class="grid grids-col-1 shadow-lg border rounded-md p-4 bg-white">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Agregar nuevo colaborador</h3>
                            <form @submit.prevent="submit">
                                <FormField label="Apellidos y Nombres" required>
                                    <FormControl v-model="form.apellidos" type="text" required placeholder="Apellidos" />
                                    <FormControl v-model="form.nombres" type="text" required placeholder="Nombres" />
                                    <FormControl v-model="form.sexo" type="select" :options="optionsGenero" placeholder="Género" />
                                </FormField>
                                <FormField label="Email/ Documento" required>
                                    <FormControl v-model="form.email" type="email" :icon="mdiMail" placeholder="Email" required />
                                    <FormControl v-model="form.id_type_document" type="select" :options="typeDocuments" />
                                    <FormControl v-model="form.num_doc" type="text" required />
                                </FormField>
                                <FormField label="Información de contacto/Nacimiento">
                                    <FormControl v-model="form.telefono" type="tel" placeholder="Teléfono fijo" />
                                    <FormControl v-model="form.celular" type="tel" placeholder="Celular" />
                                    <FormControl v-model="form.fecha_nacimiento" type="date" />
                                    <FormControl v-model="form.id_distrito_nacimiento" type="select" :options="distritos" placeholder="Distrito de nacimiento" />
                                </FormField>
                                <FormField label="Domicilio">
                                    <FormControl v-model="form.domicilio" type="text" placeholder="Dirección" />
                                    <FormControl v-model="form.id_distrito_domicilio" type="select" :options="distritos" placeholder="Distrito" />
                                    <FormControl v-model="form.referencia" type="text" placeholder="Referencia de domicilio" />
                                </FormField>



                                <!-- Datos de colaborador -->
                                <!-- <FormField label="Datos de la vivienda/Situación educativa" :help="form.vivienda = selectVivienda + ' : ' + textVivienda" required>
                                            <FormControl v-model="selectVivienda" type="select" :options="optionsVivienda" placeholder="Tipo de vivienda"/>
                                            <FormControl v-model="textVivienda" type="text" placeholder="Información adicional"/>
                                            <FormControl v-model="form.id_situation_education" type="select" :options="situationeducations" placeholder="Situación educativa" required/>
                                            <FormControl v-model="form.recurso_prestado" type="text" labelinput="Recurso prestado" tooltipcontent="Algún recurso prestado por la institución (laptop, impresora, etc)"/>
                                        </FormField>

                                        <FormField label="Fecha inicio de labores/Puesto laboral/Afp" >
                                            <FormControl v-model="form.fecha_inicio_laboral" type="date" />
                                            <FormControl v-model="form.id_puesto_laboral" type="select" :options="puestolaborales" placeholder="Puesto laboral" />
                                            <FormControl v-model="form.id_afp" type="select" :options="afps" placeholder="AFP" />
                                            <FormControl v-model="form.note" type="text" labelinput="Nota adicional" tooltipcontent="Cualquier otra información"/>
                                        </FormField> -->

                                <!-- <FormField label="Seguro de salud/Cuenta Bancaria" :help="form.seguro = selectSeguroSalud + ' : ' + textSeguroSalud">
                                            <FormControl v-model="selectSeguroSalud" type="select" :options="optionsSeguroSalud"/>
                                            <FormControl v-model="textSeguroSalud" type="text" :placeholder="selectSeguroSalud == optionsSeguroSalud[0] ? 'Dónde?' : 'Información opcional del seguro'"/>
                                            <FormControl v-model="form.cuenta_bancaria" type="text" placeholder="Cuenta bancaria"/>
                                        </FormField> -->

                                <!-- <FormField label="Datos de Login">
                                            <FormControl v-model="form.user_status" type="yesno" labelinput="Acceso al sistema?" placeholder="tiene acceso" tooltipcontent="Por defecto el usuario es el correo y el password es el documento"/>
                                            <FormControl v-if="form.user_status == 1" v-model="form.id_rol" type="select" :options="roles" labelinput="Rol de usuario" tooltipcontenthtml="
                                            <p>
                                                <strong>Gerencial TI</strong> : Para los gerentes, promotores con acceso a todo.<br>
                                                <strong>Administrador</strong> : Para los adminsitradores de sistemas y finanzas con acceso a todo, ver, modificar y crear.<br>
                                                <strong>AdminCoord</strong> : Asistente administrativo o coordinadores con privilegios elevados, puede crear y modificar datos.<br>
                                                <strong>Coordinador</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas.<br>
                                                <strong>Secretaria</strong> : Tiene acceso a sólo ver la lista de estudiantes y sus fichas.<br>
                                                <strong>Maestro</strong> : Tiene acceso a sólo ver las aulas asignadas y los estudiantes de estas, ver, crear y modificar las tareas según su curso asignado.<br>
                                                <strong>Diseñador</strong> : Tiene acceso a sólo ver, crear y modificar las guías de estudio.
                                               
                                            </p>
                                            " />
                                        </FormField> -->

                                <div class="flex items-center justify-end mt-4">

                                    <!-- <Link :href="route('student')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Volver al listado
                                            </Link> -->
                                    <!-- <BaseButton
                                                color="contrast"
                                                :href="route('student')"
                                                small
                                                label=" Cancelar"
                                                class="ml-4"
                                            /> -->
                                    <Link :href="route('collaborator-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                    </Link>
                                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                        Registrar
                                    </BreezeButton>
                                </div>
                            </form>
                        </div>
                    </template>

                </template>
                <template v-else-if="(tab == 3 && isAdmin)">
                    <div class="grid grids-col-1 shadow-lg border rounded-md p-4 bg-white">
                        <h2 class="font-semibold text-xl text-gray-800 leading-tight">Turnos de asistencia - {{ object.apellidos + ' ' + object.nombres }}</h2>
                        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                            <li>Puede asignar más de un turno de asistencia pero los horarios o días no deben coincidir entre ellas.</li>
                            <div class="p-6 bg-white border-b border-gray-200">

                                <CardBox class="mb-6 w-full overflow-x-auto" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableSingle :debugInertia="debugInertia" modulo="collaboratorturn-user" :src_id="object.id" :data="object.collaboratorturns" :select1="collaboratorturns" :select2="entidades" ruta="collaborator-turn" deleteable nosearchable nostatus noupdate showRefresh :actionRefresh="['object']" />
                                </CardBox>

                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="(tab == 4)">
                    <div class="grid grids-col-1 shadow-lg border rounded-md p-4 bg-white">
                        <h3 class="md:text-2xl text-xl my-4 font-bold">Carpeta de recuperación</h3>
                        Carpeta de recuperación
                    </div>
                </template>
                <template v-else-if="(tab == 5)">
                    <div class="grid grids-col-1 shadow-lg border rounded-md p-4 bg-white">
                        <h3 class="md:text-2xl text-xl my-4 font-bold">Histórico de notas</h3>
                        <div class="grid grid-cols-1 gap-6 mb-6">
                            <div class="flex flex-col"><!-- LRR justify-between para dos áreas con el mimos ancho o no se -->
                                <!--:date="client.created"-->
                                <!--{{ object.ciclos }} object.id_distrito_domicilio ? distritos.find(item => item.id === object.id_distrito_domicilio ).label : ''-->

                                <div v-for="(ciclo, index) in object.ciclos" :key="ciclo.id"> Año escolar {{ ciclo.anio }}
                                    <button @click="showNotas[index] = !showNotas[index]" type="button">Mostrar / ocultar</button>
                                    <div v-if="showNotas[index] == true">
                                        <CardBoxCiclo v-for="cursodeciclo in ciclo.ciclodets" :key="cursodeciclo.id" :cursos="cursos" :curso="cursodeciclo.id_course" :asistencia="parseInt(cursodeciclo.asistencia)" :participacion="parseInt(cursodeciclo.participacion)" :tarea="parseInt(cursodeciclo.tarea)" :conducta="parseInt(cursodeciclo.conducta)" :examen_parcial="parseInt(cursodeciclo.examen_parcial)" :examen_parcial2="parseInt(cursodeciclo.examen_parcial2)" :examen_final="parseInt(cursodeciclo.examen_final)" :label="cursodeciclo.label" :progress="parseInt(cursodeciclo.promedio)" />
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="(tab == 10)">
                    <div class="grid grids-col-1 shadow-lg border rounded-md p-4 bg-white">
                        <h3 class="md:text-2xl text-xl my-4 font-bold">Agenda</h3>
                        <!-- Documentación: https://antoniandre.github.io/vue-cal/?ref=madewithvuejs.com -->
                        <!-- Ejemplo: https://codepen.io/antoniandre/pen/jJbygw?editors=1010 -->
                        <!-- If the container has no height, set a height on vue-cal -->
                        <div class="container">
                            <VueCal :time="false" locale="es" :disable-views="['years', 'year']" :events="events" />
                        </div>
                    </div>
                </template>
            </div>
        </div>


    </BreezeAuthenticatedLayout>
</template>
